<template>
  <el-card
    id="LGACard"
    shadow="hover"
    class="clear-card mainCard detailsCard"
  >
    <div
      slot="header"
      class="clearfix title header defaultCursor"
    >
      <span>{{ $t('common.lgaLong') }}</span>
      <el-tooltip
        style="padding-left: 5px;"
        effect="dark"
        placement="top"
        :content="$t('coach.leader.lga.whenOpen')"
      >
        <i class="el-icon-info"></i>
      </el-tooltip>
    </div>
    <div
      v-if="leader.lga && (leader.lga.lga1 || leader.lga.lga2)"
      class="dataWrap"
    >
      <div
        v-if="leader.lga.lga1"
        class="lga"
      >
        {{ leader.lga.lga1 }}
      </div>
      <div
        v-if="leader.lga.lga2"
        class="lga"
      >
        {{ leader.lga.lga2 }}
      </div>

      <div
        v-if="leader.lga.is_editable"
        class="lgaActionWrap"
      >
        <el-button
          class="clearBtn"
          type="default"
          round
          @click="editorDialog = true"
        >
          {{ $t('common.edit') }}
        </el-button>
      </div>
    </div>
    <div
      v-else
      class="no-data"
    >
      {{ $t('common.noData') }}
    </div>

    <LGAEditor
      :show.sync="editorDialog"
      :lga.sync="lgaLocal"
    />
  </el-card>
</template>

<script>
import LGAEditor from './LGAEditor.vue';

export default {
  name: 'LGA',

  components: {
    LGAEditor,
  },

  props: {
    leader: {
      type: Object,
      default: null,
    },

    lga: {
      type: Object,
      default: null,
    },
  },

  data: () => ({
    editorDialog: false,
  }),

  computed: {
    lgaLocal: {
      get() {
        return this.lga;
      },
      set(newValue) {
        this.$emit('update:lga', newValue);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
  #LGACard {
    min-height: 154px;

    .dataWrap {
      flex-wrap: wrap;

      .lga {
        display: flex;
        width: 100%;
        justify-content: center;
        text-align: center;
        padding: 5px 0;
        font-size: 18px;
        font-weight: bold;
        font-style: italic;
      }

      .lgaActionWrap {
        display: flex;
        width: 100%;
        justify-content: center;
        padding-top: 10px;

        .clearBtn {
          padding: 10px 5px;
          min-width: 120px;
          background-color: transparent;
          color: var(--themeFontColor);
        }
      }
    }

    .no-data {
      display: flex;
      height: 100%;
      justify-content: center;
      align-items: center;
      font-style: italic;
      color: #c4c4c4;
    }
  }
</style>

<style lang="scss">
#LGACard {
  .el-card__body {
    height: calc(100% - 95px);
  }

  .el-card__header {
    text-align: center;
    font-weight: bold;
  }

  &.mobile {
    .el-card__header {
      border-bottom: none;
    }
  }
}
</style>
